import {
  cycleLifecycleDisplayBadgeClass,
  cycleLifecycleDisplayLabel,
  type CycleLifecycleDisplayStatus,
} from '@/lib/cycleLifecycleDisplayStatus';

export function CycleLifecycleStatusBadge({
  status,
  className = '',
}: {
  status: CycleLifecycleDisplayStatus;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border capitalize ${cycleLifecycleDisplayBadgeClass(
        status,
      )} ${className}`.trim()}
    >
      {cycleLifecycleDisplayLabel(status)}
    </span>
  );
}
